import Tobii from "tobii";
import Blazy from "blazy";
import getAverageColor from "./averageColor";

const html = document.querySelector("html");
const body = document.querySelector("body");
body.classList.add("js");

if (document.querySelectorAll(".lightbox").length > 0) {
	new Tobii();
}

new Blazy({
	selector: ".lazy",
	successClass: "loaded",
	success: function(element) {
		// console.log(element.parentElement);
		// get the average color of header images
		// if (element.parentElement.classList.contains("page-header-image")) {
		// 	let avg = getAverageColor(element);
		// 	console.log(avg);
		// 	element.parentElement.style.backgroundColor = `rgb(${avg.r},${avg.g},${avg.b})`;
		// }
	}
});

/** Toggle the mobile menu
* @returns {void}
*/
function toggleMobileMenu() {
	html.classList.toggle("menu-opened");
}

document.querySelector(".menu-toggler").addEventListener(
	"click",
	function(e) {
		e.preventDefault();
		toggleMobileMenu();
	},
	false
);

document.querySelector(".search-toggler").addEventListener(
	"click",
	function(e) {
		e.preventDefault();

		let mobileSearchEl = document.getElementById("mobileSearch");

		if (html.classList.contains("menu-opened")) {
			mobileSearchEl.focus();
		} else {
			html.classList.add("menu-opened");
			mobileSearchEl.focus();
		}

		return false;
	},
	false
);

/** calculate the height of the mobile bar
 * @returns {void} nothin
 */
function calcMobileBarHeight() {
	// console.log("calculate mobile bar height");
	let mobileBar = document.querySelector(".mobile-bar");
	let mobileMenu = document.querySelector(".mobile-menu");
	body.style.paddingTop = mobileBar.offsetHeight + "px";
	mobileMenu.style.paddingTop = mobileBar.offsetHeight + "px";
}

window.addEventListener("resize", calcMobileBarHeight);
window.addEventListener("load", calcMobileBarHeight);

//megamenu mobile
var mainItemsMobile = document.querySelectorAll('.mobile-arrow');
var megamenuItemsMobile  = document.querySelectorAll('.megamenu-item-mob');
var megamenuMobile  = document.getElementById('megamenu-mobile');
//
// megamenuMobile .addEventListener("click", function( e ) {
// 	megamenuMobile .classList.add('active');
// });
// megamenuMobile .addEventListener("click", function( e ) {
// 	megamenuMobile .classList.remove('active');
// });
var close = document.getElementsByClassName('close-arrow')[0];

for (var i = 0; i < mainItemsMobile.length; i++) {
	mainItemsMobile[i].addEventListener("click", function( e ) {
				e.target.classList.add('active');
				megamenuMobile.classList.add('active');

		for (var i = 0; i < megamenuItemsMobile .length; i++) {
			if (megamenuItemsMobile[i].classList.contains(e.target.id)) {
				megamenuItemsMobile [i].classList.add('active');
			} else {
				megamenuItemsMobile [i].classList.remove('active');
			}
		}
	});

	close.addEventListener('click', function(e){
		e.target.classList.add('remove');
		megamenuMobile.classList.remove('active');

		for (var i = 0; i < megamenuItemsMobile .length; i++) {
			if (megamenuItemsMobile[i].classList.contains(e.target.id)) {
				megamenuItemsMobile [i].classList.remove('active');
			}
		}

	})

	// mainItemsMobile [i].addEventListener("mouseleave", function( e ) {
	// 	setTimeout(function(){
	// 		megamenuMobile .classList.remove('active');
	// 	}, 1000);
	// });
}


//megamenu
var mainItems = document.querySelectorAll('.menu-item.level-1');
var megamenuItems = document.querySelectorAll('.megamenu-item.col-3');
var megamenu = document.getElementById('megamenu');

megamenu.addEventListener("mouseenter", function( e ) {
	megamenu.classList.add('active');
});
megamenu.addEventListener("mouseleave", function( e ) {
	megamenu.classList.remove('active');
});

for (var i = 0; i < mainItems.length; i++) {
	mainItems[i].addEventListener("mouseenter", function( e ) {


		for (var i = 0; i < megamenuItems.length; i++) {
			if (megamenuItems[i].classList.contains(e.target.id)) {
				setTimeout(function(){
					megamenu.classList.add('active');
				}, 200);
				megamenuItems[i].classList.add('d-block');
			} else {
				megamenuItems[i].classList.remove('d-block');
				megamenu.classList.remove('active');
			}
		}
	});
}

// var prevScrollpos = window.pageYOffset;
// 	window.onscroll = function() {
// 	  var currentScrollPos = window.pageYOffset;
//
// 		var menu = document.getElementsByClassName('site-header')[0];
// 		var dropdown = document.getElementById('megamenu');
// 		var smallLogo = document.getElementsByClassName('smalllogo')[0];
// 		var bigLogo = document.getElementsByClassName('bigLogo')[0];
// 		var remainingMenu = document.getElementsByClassName('header-menu')[0];
//
// 		if (( prevScrollpos ) > currentScrollPos || currentScrollPos < 35) {
// 			menu.classList.remove('scrolled');
// 			dropdown.style.top = '';
// 			smallLogo.classList.add('d-none');
// 			bigLogo.classList.remove('d-none');
// 			// remainingMenu.classList.remove('offset-sm-3');
// 			// remainingMenu.classList.remove('col-sm-9');
// 		} else {
// 			menu.classList.add('scrolled');
// 			dropdown.style.top = '55px';
// 			smallLogo.classList.remove('d-none');
// 			bigLogo.classList.add('d-none');
// 			// remainingMenu.classList.add('offset-sm-3');
// 		}
// 		prevScrollpos = currentScrollPos;
// }
console.log('test');
